import * as React from "react";
import { Dialog, DialogContent, DialogActions, Typography, Slide } from "@mui/material";
//import { styled } from '@mui/material/styles';
//import { makeStyles } from "@mui/styles";
//import red from "@mui/material/colors/red";
/* 
const useStyles = makeStyles(() => ({
  dialog: {
    borderRadius: 5,
    padding: 10
  },
  button: {
    borderRadius: 0,
    textTransform: "none",
    padding: 5
  },
  logout: {
    color: "#fff",
    backgroundColor: red[500],
    "&:hover": {
      backgroundColor: red[700]
    }
  },
  countdown: {
    color: red[700]
  }
})); */

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const SessionTimeoutDialog = ({ open, countdown, onLogout, onContinue }) => {
  //const classes = useStyles();

  return (
    <Dialog
      open={open}
      className="session_dialog"
      TransitionComponent={Transition}
    >
      <h2 className="session_title">Session Timeout</h2>
      <DialogContent>
        <Typography variant="body2">
          The current session is about to expire in{" "}
          <span className="session_countdown">{countdown}</span> seconds.
        </Typography>
        <Typography variant="body2">{`Would you like to continue the session?`}</Typography>
      </DialogContent>
      <DialogActions >
        <button className="session_button session_btn_logout" onClick={onLogout}><span> Logout</span></button>
        <button className="session_button session_btn_continue" onClick={onContinue}><span> Continue Session</span></button>
      </DialogActions>
    </Dialog>
  );
};

export default SessionTimeoutDialog;